import React from "react";
import { Box, Center, Flex, Heading, Image, Link, Stack, Text } from "@chakra-ui/react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { options } from "api/contentful/options";
import Rocket from "assets/rocket.svg";

interface Props {
  videoLink?: any;
  videoTitle?: any;
  videoDescription?: any;
  videoImage?: any;
}

const VideoCard: React.FC<Props> = ({ videoLink, videoTitle, videoDescription, videoImage }: Props) => {
  const getVideoLink = (): void => {
    window.open(videoLink);
  };

  return (
    <Box
      bg="gray.800"
      boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
      borderRadius="15px"
      position="relative"
      w="100%"
    >
      <Stack direction="column">
        {videoImage==null ? (
          <Box
            as='button'
            onClick={getVideoLink}
          >
            <Image
              src={Rocket}
              borderRadius='lg'
              w="100%"
            />
          </Box>
        ) : (
          <Box
            as='button'
            onClick={getVideoLink}
          >
            <Image
              src={videoImage}
              borderRadius='xl'
              w="100%"
            />
          </Box>
        )}
        {videoTitle == null? (
          <Heading size="md" p={4}>
            Video Title
          </Heading>
        ) : (
          <Heading size="md" p={4}>
            <Link onClick={getVideoLink}>
              {videoTitle}
            </Link>
          </Heading>
        )}
        {videoDescription == null ? (
          <Text pl={4} pr={4} pb={4}>
              Video description with long line of text to check spacing and overflow
          </Text>
        ) : (
          <Text pl={4} pr={4} pb={4}>
              {videoDescription && documentToReactComponents(videoDescription, options)}
          </Text>
        )}
      </Stack>
    </Box>
  );
};

export default VideoCard;
